import React from "react"
import sortBy from "lodash/sortBy"
import map from "lodash/map"
import {
  Table,
  Card,
  CardBody,
  Badge,
  //ListGroup,
  //ListGroupItem,
} from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useFuzzy } from "react-use-fuzzy"
import { faCubes } from "@fortawesome/free-solid-svg-icons/faCubes"
import { faCube } from "@fortawesome/free-solid-svg-icons/faCube"
import { faLink } from "@fortawesome/free-solid-svg-icons/faLink"
//import { faDotCircle } from "@fortawesome/free-solid-svg-icons/faDotCircle"
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons/faMinusCircle"
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft"
import styled from "styled-components"
import { UnControlled as CodeMirror } from "react-codemirror2"
import "codemirror/lib/codemirror.css"
import "codemirror/theme/solarized.css"
import Container from "../components/Container"
import Layout from "../components/layout"
import MultiLineText from "../components/MultiLineText"
import SEO from "../components/seo"
import { LICENSE_PREFIX } from "../constants"

import "../styles/global.css"
import { Link } from "gatsby"
import SearchInput from "../components/SearchInput"
import _ from "lodash"

var canUseDOM = !!(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
)

if (canUseDOM) {
  require("codemirror/mode/sql/sql")
  require("codemirror/mode/spreadsheet/spreadsheet")
}

const CustomCodeMirror = styled(CodeMirror)`
  .CodeMirror {
    height: auto;
  }
  .cm-s-solarized.CodeMirror {
    -moz-box-shadow: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
`

function splitByPrivate(fields) {
  const primaryFields = []
  const privateFields = []

  fields.forEach(f => {
    if (f.private) {
      privateFields.push(f)
    } else {
      primaryFields.push(f)
    }
  })

  return [primaryFields, privateFields]
}

function sortByDeprecated(fields) {
  const nonDeprecatedFields = []
  const deprecatedFields = []

  fields.forEach(f => {
    if (f.deprecated) {
      deprecatedFields.push(f)
    } else {
      nonDeprecatedFields.push(f)
    }
  })
  
  return nonDeprecatedFields.concat(deprecatedFields)
}

function entityFieldLink(field) {
  const tagIndex = field.reference.indexOf('>');
  const url = _.kebabCase(field.reference.substring(0, tagIndex));
  const tag = field.reference.substring(tagIndex + 1);

  return `/entity/${url}#${tag}`;
}

function EntityDetail({ pageContext: { entity } }) {
  const sortedFields = map(
    sortBy(entity.fields, field => field.name.toLowerCase()),
    field => ({
      ...field,
      meta: field.deprecated ? "deprecated" : "",
    })
  )
  const { result, keyword, search } = useFuzzy(sortedFields, {
    keys: ["name", "enumValues", "enumDefinitions", "description", "type", "reference", "comments", "enumValue", "meta"],
  })
  const [publicFields] = splitByPrivate(sortByDeprecated(result));

  return (
    <Layout>
      <SEO title={`${entity.name} Reference`} />

      <div className="bg-white p-2 shadow-sm">
        <Container className="mb-2">
          <h6 className="mb-3">
            <Link to="/" className="mb-n1">
              <FontAwesomeIcon icon={faChevronLeft} style={{fontSize: "1.1rem"}}/> 
              &nbsp;
              <span style={{fontSize: "1.1rem"}}>
                Back</span>
            </Link>
          </h6>       
          <h4 className="mb-3">
            <FontAwesomeIcon icon={faCubes} style={{color: "#4B5EAA"}}/>
            &nbsp;&nbsp;
            <span style={{color: "#4B5EAA", fontWeight: "bold", fontSize: "1.4rem"}}>
              <strong>{entity.name}</strong>
            </span>
          </h4>            
          <SearchInput value={keyword} onValueChange={search} placeholder = "Search field names and details" style={{fontSize: "1.1rem"}}/>
        </Container>
      </div>

      <Container className="pb-4">
        <br />
        <h5 style= {{color: "#344041"}}><b>Description</b></h5>
        <Card className="shadow-sm">
          <CardBody className="p-0">
            <div style={{ padding: "1.2em", fontSize: "1.1rem", color: "#5C6670"}}>
              <MultiLineText> 
                {entity.detailedDescription}
              </MultiLineText>
            </div>
          </CardBody>
        </Card>
        <br />
        <h5 style= {{color: "#344041"}}><b>Fields</b></h5>
        <Card className="shadow-sm">
          <CardBody className="p-0">
            <Table className="mb-0">
              <tbody style={{ fontSize: "1.2rem" }}>
                {publicFields.map((field, index) => (
                  <tr id={field.name} key={field.id}>
                    <td className="pr-0">
                      <div className="font-weight-bold mt-2" style={{ whiteSpace: "nowrap", color: "#5C6670"}}>
                        <FontAwesomeIcon icon={faCube} style={{"color": field.deprecated  ? "#FDB913" : field.reference ? "#50B848" : "" }}/>
                        &nbsp;&nbsp;
                        {field.name}
                        &nbsp; &nbsp;
                        <Badge style={{ color: "#FFFFFF", backgroundColor: "#4B5EAA", fontSize: "1rem", fontStyle: "normal"}}>
                          <span style={{ fontWeight: "normal"}}>
                            {field.type}
                          </span>
                        </Badge>
                        &nbsp; &nbsp; 
                        {field.deprecated && (
                          <Badge className="ml-1" style={{ backgroundColor: "#FDB913", fontSize: "1rem", fontStyle: "normal" }}>
                            <FontAwesomeIcon icon={faMinusCircle} style={{color: "#5C6670"}}/>
                            &nbsp;
                            <span style={{fontWeight: "normal"}}>
                              deprecated
                            </span>
                          </Badge>
                        )}
                        {field.reference && (
                          <Link to={entityFieldLink(field)} style={{ marginLeft: ".1em"}}>
                          {
                            <Badge className="ml-1" style={{ color: "#FFFFFF", backgroundColor: "#50B848", fontSize: "1rem", fontStyle: "normal" }}>
                              <FontAwesomeIcon icon={faLink} style={{ color: "#5C6670"}}/>{" "}
                              <span style={{ fontWeight: "normal"}}>
                                {field.reference}
                              </span>
                            </Badge> }
                          </Link>
                        )}
                      </div>
                      {field.description && (
                        <>
                        <div style={{ paddingTop:".2em", paddingBottom: ".5em", paddingLeft: "1.57em", fontSize: "1.1rem", color: "#5C6670"}}>
                          <MultiLineText>{field.description}</MultiLineText>
                        </div>
                        </>
                      )}
                      {field.comments && (
                        <>
                          <div className="font-weight-bold" style={{ paddingTop:".8em", paddingLeft:"1.5em", fontSize: "1.15rem", color: "#4B5EAA"}}>
                            <strong>Additional Notes</strong>
                          </div>
                          <div style={{ paddingTop:".2em", paddingLeft:"2.5em", paddingBottom: ".5em", fontSize: "1.1rem", color: "#5C6670"}}>
                            <MultiLineText>{field.comments}</MultiLineText>
                          </div>
                        </>
                      )}
                      {field.enumValues && (
                        <>
                          <div style={{ paddingTop:".8em", paddingLeft:"1.5em", fontSize: "1.15rem", color: "#4B5EAA"}}>
                            <strong>Allowed Values</strong>
                            <ul style={{ paddingTop:".2em", paddingLeft:"2em", fontSize: "1.1rem", color: "#5C6670"}}> 
                              {field.enumValues &&
                                field.enumValues.map(enumValue => (
                                  <li>
                                    {enumValue}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </>
                      )}
                      {field.enumDefinitions && (
                        <>
                          <div className="font-weight-bold" style={{ paddingTop:".8em", paddingLeft:"1.5em", fontSize: "1.15rem", color: "#4B5EAA"}}>
                            <strong>Allowed Value Details</strong>
                          </div>
                          <div style={{ paddingTop:".2em", paddingLeft:"2.5em", paddingBottom: ".5em", fontSize: "1.1rem", color: "#5C6670"}}>
                            <MultiLineText>{field.enumDefinitions}</MultiLineText>
                          </div>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
                {publicFields.length === 0 && (
                  <tr>
                    <td className="pr-2" colSpan="2">
                      No matching fields
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
        {entity && entity.query && (
          <>
            <br />
            <h5 style= {{color: "#344041"}}><b>Example SQL</b></h5>
            <Card>
              <CardBody className="p-0">
                <div style={{fontSize: "1rem"}}>
                  <CustomCodeMirror
                    id="editor"
                    value={LICENSE_PREFIX + entity.query}
                    inputProps={{
                      "aria-label": "Write query",
                      "aria-labelledby": "editor-title",
                    }}
                    autoCursor
                    name="Query Pan"
                    options={{
                      readOnly: true,
                      mode: canUseDOM ? "sql" : undefined,
                      theme: "solarized",
                      autoCursor: true,
                      lineNumbers: true,
                      //lineWrapping: true,
                      viewportMargin: Infinity, // Bug Fix, removing this causes flicker when nwriting query with lots of lines
                      inputProps: {
                        "aria-label": "Write query",
                        "aria-labelledby": "editor-title",
                      },
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </>
        )}
        {entity && entity.config && entity.config.csvFile && (
          <>
            <br />
            <h5 style= {{color: "#344041"}}><b>CSV Datasource</b></h5>
            <Card>
              <div style={{fontSize: ".8rem"}}>
                <CustomCodeMirror
                  id="editor"
                  value={entity.config.csvFile}
                  inputProps={{
                    "aria-label": "Write query",
                    "aria-labelledby": "editor-title",
                  }}
                  autoCursor
                  name="Query Pan"
                  options={{
                    readOnly: true,
                    mode: canUseDOM ? "spreadsheet" : undefined,
                    theme: "solarized",
                    autoCursor: true,
                    lineNumbers: true,
                    viewportMargin: Infinity, // Bug Fix, removing this causes flicker when nwriting query with lots of lines
                    inputProps: {
                      "aria-label": "Write query",
                      "aria-labelledby": "editor-title",
                    },
                  }}
                />
              </div>
            </Card>
          </>
        )}
      </Container>
    </Layout>
  )
}

export default EntityDetail
